module.exports = __webpack_public_path__ + "img/Locker Icon - white.e34c15c4.svg";